/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Table as AntdTable,Empty } from 'antd';
import { ColumnsType } from 'antd/es/table';
import TableHeader, { ITableHeader } from './TableHeader';
import {useIntl} from 'react-intl'

export type ITable<T> = {
    data: T[];
    columns: ColumnsType<T>;
    rowSelect?: 'single' | 'multiple';
    metaData?: any;
    onPageChange?: (page: any, pageSize: any) => void;
    tableHeader?: ITableHeader;
    onRow?: any;
    rowKey?: any;
    pageSize?: number;
    totalRecordCount?: number;
    disablePagination?: boolean;
    rowClassName?: (record: T, index: number) => string;
    
};

type TableProps = {
    dataSource: any[];
    columns: any[];
    rowSelection?: any;
};

const Table = <T extends object>(props: ITable<T>) => {
    const intl=useIntl();
    const [pagination, setPagination] = useState({
		pageSize: props.pageSize,
        total: props.totalRecordCount,
        showSizeChanger: true,
        locale:{ items_per_page: `${intl.formatMessage({ id: 'page' })}`},
        showTotal: (total: any, range: any) => `${range[0]}-${range[1]} ${intl.formatMessage({ id: 'of' })} ${total} ${intl.formatMessage({ id: 'items' })}`,
        onShowSizeChange: (page: any, pageSize: any) => {
            setPagination({
                ...pagination,
                pageSize: pageSize
            });
            // props.onPageChange
        },
        onChange: props.onPageChange,
	});
    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[]) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
    };

    useEffect(() => {
        setPagination({
            pageSize: props.pageSize,
            total: props.totalRecordCount,
            showSizeChanger: true,
            locale:{ items_per_page: `${intl.formatMessage({ id: 'page' })}`},
            showTotal: (total: any, range: any) => `${range[0]}-${range[1]} ${intl.formatMessage({ id: 'of' })} ${total} ${intl.formatMessage({ id: 'items' })}`,
            onShowSizeChange: (page: any, pageSize: any) => {
                setPagination({
                    ...pagination,
                    pageSize: pageSize
                });
                // props.onPageChange
            },
            onChange: props.onPageChange,
        });
    },[props.data, props.metaData,intl]);

    const tableProps: TableProps = {
        dataSource: props.data,
        columns: props.columns,
    };

    if (props.rowSelect) {
        tableProps.rowSelection = {
            ...rowSelection,
            type: props.rowSelect ? (props.rowSelect === 'single' ? 'radio' : 'checkbox') : undefined,
        };
    }

    return (
        <React.Fragment>
            {props.tableHeader && <TableHeader {...props.tableHeader} />}
            <AntdTable
                // scroll={{ x: 0, y: '50vh' }}
                // pagination={pagination}
                 pagination={props.disablePagination ? false : pagination}
                 rowClassName={props.rowClassName}
                rowKey={props.rowKey}
                // style={{padding : '0% 3%'}}
                locale={{ emptyText: <Empty description={intl.formatMessage({id: 'no_data'})} />, }}
                onRow={(record) => {
                    return {
                        onClick: () => props?.onRow(record), // click row
                    };
                }}
                bordered
                {...tableProps}
            ></AntdTable>
        </React.Fragment>
    );
};

export default Table;
